import React from 'react';
import { connect } from 'react-redux';
import { Responsive, userLogout as userLogoutAction } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ExitIcon from '@material-ui/icons/PowerSettingsNew';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core/';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const styles = {
  root: {
    padding: '5px 10px',
    color: '#ffffff',
    margin: '10px 24px'
  },
  smallMenuItem: {
    textTransform: 'none'
  },
  icon: {
    minWidth: '10px',
    color: '#ffffff',
    paddingRight: '1em'
  }
};

const SolsticeLogoutButton = withStyles(styles)(({ classes, userLogout }) => (
  <Responsive
    xsmall={
      <MenuItem onClick={userLogout}>
        <ListItemIcon className={classes.icon}>
          <ExitIcon />
        </ListItemIcon>
        <Typography
          variant="button"
          color="inherit"
          className={classes.smallMenuItem}
        >
          Logout
        </Typography>
      </MenuItem>
    }
    medium={
      <Button onClick={userLogout} size="small" className={classes.root}>
        <ListItemIcon className={classes.icon}>
          <ExitIcon />
        </ListItemIcon>
        <Typography
          variant="button"
          color="initial"
          style={{ textTransform: 'none' }}
        >
          Logout
        </Typography>
      </Button>
    }
  />
));

const mapDispatchToProps = dispatch => ({
  userLogout: () => {
    return dispatch(userLogoutAction());
  }
});

export default connect(undefined, mapDispatchToProps)(SolsticeLogoutButton);
